import * as _ from 'lodash';
import * as TenantGroupSystemNames from '../data/tenantGroupSystemNames.json';
import * as tenants_tid1 from '../data/tenants-tid1.json';
import * as tenants_tid2 from '../data/tenants-tid2.json';
import * as tenants_tid3 from '../data/tenants-tid3.json';
import * as tenants_tid4 from '../data/tenants-tid4.json';
import * as tenants_tid5 from '../data/tenants-tid5.json';
import * as tenants_tid6 from '../data/tenants-tid6.json';
import * as tenants_tid100 from '../data/tenants-tid100.json';
import * as tenants_tid101 from '../data/tenants-tid101.json';
import * as tenants_tid102 from '../data/tenants-tid102.json';
import * as tenants_tid103 from '../data/tenants-tid103.json';
import * as tenants_tid104 from '../data/tenants-tid104.json';
import * as tenants_tid109 from '../data/tenants-tid109.json';
import * as tenants_tid200 from '../data/tenants-tid200.json';
import * as tenants_tid300 from '../data/tenants-tid300.json';
import * as tenants_tid600 from '../data/tenants-tid600.json';
import * as tenants_tid700 from '../data/tenants-tid700.json';
import * as tenants_tid800 from '../data/tenants-tid800.json';
import * as tenants_tid900 from '../data/tenants-tid900.json';
import * as bm100 from '../data/tenants-tid-demo-bm100.json';
import * as bm2 from '../data/tenants-tid-demo-bm2.json';
import * as bm6 from '../data/tenants-tid-demo-bm6.json';
import * as oneClickBm100 from '../data/tenants-tid-one-click-bm100.json';
import * as tenantDefaultTimezone from '../data/tenantDefaultTimezone.json';
import * as sunsetGroup from '../data/sunsetGroup.json';
import { demoTenantBusinessModels, oneClickTenantIdStart } from '../libraries/DomainCoreGeneration';
import { replaceTenantIdForBm } from '../libraries/Utils';
const tenantData = {
    '1': tenants_tid1,
    '2': tenants_tid2,
    '3': tenants_tid3,
    '4': tenants_tid4,
    '5': tenants_tid5,
    '6': tenants_tid6,
    '100': tenants_tid100,
    '101': tenants_tid101,
    '102': tenants_tid102,
    '103': tenants_tid103,
    '104': tenants_tid104,
    '109': tenants_tid109,
    '200': tenants_tid200,
    '300': tenants_tid300,
    '600': tenants_tid600,
    '700': tenants_tid700,
    '800': tenants_tid800,
    '900': tenants_tid900,
    bm2,
    bm6,
    bm100,
    oneClickBm100,
};
const TenantMgr = (tid) => {
    const getTenantData = (appendDisableFeature = true) => {
        const tenantsDefault = {
            smsVerificationLimit: 99999999,
            vat: 0,
            smileyReportsSearchUrl: 'http://www.findsmiley.dk/Sider/Search.aspx',
            locale: 'en',
        };
        function extendTenant(tenantsDefault) {
            const tenantSpecificData = Object.keys(demoTenantBusinessModels).includes(tid.toString())
                ? replaceTenantIdForBm(tenantData[demoTenantBusinessModels[tid]], tid)
                : tid >= oneClickTenantIdStart
                    ? tenantData['oneClickBm100']
                    : tenantData[tid.toString()];
            return _.extend(tenantsDefault, tenantSpecificData);
        }
        const tenantConfig = extendTenant(tenantsDefault);
        if (appendDisableFeature) {
            tenantConfig;
            tenantConfig.isFeatureDisabled = isFeatureDisabled;
        }
        const mandatoryFields = [
            'businessModelId',
            'tenantId',
            'tenantName',
            'siteNotAvailableRedirectUrl',
            'defaultChannelAlias',
            'tenantIdPathName',
            'imageRootFolder',
            'fromEmail',
            'defaultLeadTime',
            'currency',
            'countryIsoCode',
        ];
        const diff = _.difference(mandatoryFields, Object.keys(tenantConfig));
        if (diff.length > 0) {
            throw new Error(`Tenant ${tid} data in domains are lacking these configs: ${diff.join(', ')}`);
        }
        return Object.freeze(tenantConfig);
    };
    const isFeatureDisabled = (featureType, feature) => {
        const tenantConfig = getTenantData(false);
        return (tenantConfig.disabledAdminFeatures &&
            tenantConfig.disabledAdminFeatures[featureType] &&
            tenantConfig.disabledAdminFeatures[featureType].includes(feature));
    };
    const getTenantGroupData = () => {
        if (Object.keys(TenantGroupSystemNames.sunsetGroup)
            .map((tenantId) => +tenantId)
            .includes(tid)) {
            return sunsetGroup;
        }
        return null;
    };
    const getDefaultTimezone = () => {
        var _a;
        return (_a = tenantDefaultTimezone.find(({ tenantIds }) => tenantIds.includes(tid))) !== null && _a !== void 0 ? _a : null;
    };
    return Object.freeze({
        getTenantData,
        isFeatureDisabled,
        getTenantGroupData,
        getDefaultTimezone,
    });
};
export default TenantMgr;
